import {EventModel} from 'event/models/Event'
import {useFormik} from 'formik'
import {PriceInput, PriceRange} from 'organization/Event/Tickets'
import React from 'react'
import {Button} from 'react-bootstrap'
import styled from 'styled-components'
import useEventPayment from 'organization/Billing/Payments/useEventPayment'
import {useOrganizationBilling} from 'organization/Billing/Providers/OrganizationBillingProvider'
import moment from 'moment'
import {formatUserDay} from 'utils/lib/date'
import {useI18n} from 'i18n/I18nContext'
import {
  getEventActivationDayPriceEur,
  getEventDayListAndPromoEur,
  eventHasDayPricePromo,
} from 'event/ticketPrices'

interface EventExtendDates {
  duration: number
}

export function EventExtend(props: {event: EventModel | null}) {
  const {event} = props
  const {t} = useI18n()
  const {payPayment} = useOrganizationBilling()
  const {payment} = useEventPayment()

  const dayDisplay = getEventActivationDayPriceEur(event)
  const {list, promo} = getEventDayListAndPromoEur(event)
  const showPromo = eventHasDayPricePromo(event) && promo != null

  const {values, setFieldValue, handleSubmit} = useFormik({
    initialValues: {
      duration: 1,
    },
    onSubmit: async (values: EventExtendDates) => {
      payPayment(
        payment({
          duration: values.duration,
        }),
      )
    },
  })

  const handleSliderChange = (e: any) => {
    setFieldValue('duration', Number(e.target.value))
  }

  const handleInputChange = (e: any) => {
    setFieldValue('duration', Number(e.target.value))
  }

  return (
    <div className="create__event-area mb-20 col-12">
      <div className="body__card-wrapper attendant__wrapper">
        <form onSubmit={handleSubmit}>
          <EventStatusHolder>
            <div>
              <p>
                <b>{t('orgEventBilling.statusLabel')} </b>
                <b style={{color: 'green'}}>{t('orgEventBilling.active')}</b>
              </p>

              <div>
                {t('orgEventBilling.activeForDates')}{' '}
                {formatUserDay(event?.date)} -{' '}
                {formatUserDay(
                  moment(event?.date)
                    .add((event?.duration ?? 1) - 1, 'days')
                    .toDate(),
                )}
              </div>

              <ActionHolder>
                <h4>{t('orgEventBilling.extendTitle')}</h4>
                <p>
                  {t('orgEventBilling.priceLabel')}{' '}
                  {showPromo ? (
                    <>
                      <s>
                        {list.toFixed(2)} € {t('orgMar.pricePerDaySuffix')}
                      </s>{' '}
                      <b>
                        {promo!.toFixed(2)} € {t('orgMar.pricePerDaySuffix')}
                      </b>
                    </>
                  ) : (
                    <b>
                      {dayDisplay.toFixed(2)} € {t('orgMar.pricePerDaySuffix')}
                    </b>
                  )}
                </p>

                <SliderHolder>
                  <PriceRange
                    type="range"
                    min="1"
                    max="7"
                    step="1"
                    value={values.duration}
                    onChange={handleSliderChange}
                  />

                  <PriceInput
                    type="number"
                    value={values.duration}
                    onChange={handleInputChange}
                  />
                </SliderHolder>

                <p>
                  {t('orgEventBilling.activeUntil')}{' '}
                  {formatUserDay(
                    moment(event?.date)
                      .add((event?.duration ?? 1) - 1 + values.duration, 'days')
                      .toDate(),
                  )}{' '}
                  {t('orgEventBilling.inclusive')}
                </p>

                <PayButtonHolder>
                  <TotalPrice>
                    {t('orgEventBilling.totalPrice')}{' '}
                    {(values.duration * dayDisplay).toFixed(2)} €
                    <br />
                  </TotalPrice>

                  <Button className="input__btn w-auto" type="submit">
                    {t('orgEventBilling.pay')}
                  </Button>
                </PayButtonHolder>
              </ActionHolder>
            </div>
          </EventStatusHolder>
        </form>
      </div>
    </div>
  )
}

const TotalPrice = styled.div`
  font-size: 20px;
`

const PayButtonHolder = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 45px;
}
`

const SliderHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`

const ActionHolder = styled.div`
  border: 1px solid #f7426f;
  border-radius: 5px;
  background-color: var(--clr-bg-pink);
  padding: 15px;
  margin-top: 15px;
`

const EventStatusHolder = styled.div`
  align-items: center;
`
